import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { selectApiKey } from 'src/state/app/appConfigSlice';
import { withAuthState } from '@trp-ta-nitro/auth-react';

/**
 * The App's header.
 *
 * Renders the CDN-delivered `ii-navigation` web component (`<secure-navigation />`).
 * The navigation scripts/styles are loaded from the CDN in `index.html`; the
 * component self-fetches its structure and data from AEM and the CDS services,
 * so only the API key needs to be supplied here.
 *
 * @constructor
 */
const Header: FC = () => {
  const apiKey = useSelector(selectApiKey);

  return (
    <div>
      <secure-navigation api-key={apiKey} variation={'minimal'} />
    </div>
  );
};

export default withAuthState(Header);
